/* lua.js generated code 0.3.0 */
var TTDesktopButton = xClass("TTDesktopButton", HomeSceneButton)

TTDesktopButton.prototype.ctor = function () {
    let self = this
    HomeSceneButton.prototype.ctor.call(self, "发送桌面", "tt_sidehint/ttDesktop.png")
    self.imageNode.setScale(0.8)
    self.bg.setOpacity(255 * 0.7)
    self.updateUI()
}
TTDesktopButton.prototype.customInit = function () {
}

TTDesktopButton.prototype.onCick =  function () {
    let self = this
    function onSuccess() {
        //Toast.make("添加成功")
    }
    function onFail(desc) {
        Toast.make("添加快捷失败")
    }
    GameProxy.getInstance().addShortcut(onSuccess, onFail)
}

TTDesktopButton.prototype.updateUI = function () {
    
}
module.exports = TTDesktopButton
